export const sanitizeCardDescription = (str) => {
  if (str == null) return ''
  return str.replaceAll(/<\/?p>/g, '')
}
